import { set } from 'cerebral/operators'

export default [set('users.searchOptions.isOpen', false)]



// WEBPACK FOOTER //
// ./src/modules/user/chains/closeSearchOption.js